import { useSelector } from "react-redux";
import { selectPageTitle, selectProjectTitle } from "./selector";

export const usePageTitle = () => useSelector(selectPageTitle);
export const useProjectTitle = () => useSelector(selectProjectTitle);
